import { render, staticRenderFns } from "./AdminAddForm.vue?vue&type=template&id=bdbd4fde&scoped=true&"
import script from "./AdminAddForm.vue?vue&type=script&lang=js&"
export * from "./AdminAddForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminAddForm.vue?vue&type=style&index=0&id=bdbd4fde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbd4fde",
  null
  
)

export default component.exports